import { Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo_white from "../../../assets/icons/fort_logo/logo_white.png";
// import logo_white from "../../../assets/icons/epislon/epsilon-logo-full-white.png";
// import logo_white from "../../../assets/icons/nuvama_logo/nuvama_logo_no_background.png";

const Header = ({ title, text }) => {
  return (
    <>
      <Container className="h-100">
        <Col sm={12} lg={4} className="highlighted-card side-card mt-5 mt-lg-0">
          {/* LOGO */}
          <Link
            className="navbar-brand"
            to={"/dashboard"}
            style={{ zIndex: 1 }}
          >
            <img src={logo_white} alt="logo" className="logo" />
          </Link>
          <h3 className="mt-4">{title}</h3>
          <p>{text}</p>
        </Col>
      </Container>

      {/* Different setup for Add and Edit (No header and therefore no need for placeholder) broker */}

      <Col sm={12} lg={4} className="px-lg-0 mt-4">
        {/* Just a holder for the absolute Col above */}
      </Col>
    </>
  );
};
export default Header;
